import { NoteTypeEnum } from './note-type.enum';

export class NoteModel {
  public link: string;
  public linkLabel: string;
  public message: string;
  public messageLine2: string | null;
  public noteType: NoteTypeEnum;
}
